exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\ninput.ng-valid[required] {\n  border-left: 5px solid #42A948;\n  /* green */ }\n\ninput.ng-invalid {\n  border-left: 5px solid #a94442;\n  /* red */ }\n\n.error {\n  padding: 12px;\n  background-color: rgba(255, 0, 0, 0.2);\n  color: red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!./src/styles.scss
// module id = 166
// module chunks = 2